import { FilterModel } from './filter-model';
import { ProductModel } from './product-model';
import { SortModel } from './sort-model';

export class AddonModel {
  filters: Array<FilterModel[]> = [];
  lastRecordIndex: number = -1;
  products: any;
  recordCount: number = -1;
  sortingItems: Array<SortModel[]> = [];
  success: boolean = false;
  categoryTitle?: string;
  bannerUrl?: string;
  currentCategory?: string;
  categoryId?: any;
  breadCrumbs?:any;
}
